/**
 * TAM SAYFA ASİSTAN — geniş yerleşim: solda sohbet, sağda ChatGPT tarzı
 * sohbet geçmişi listesi + Yeni Sohbet (withThreads). Orb sidebar'da yaşar.
 */
import { AssistantChat } from "@/components/assistant-chat";

export default function Assistant() {
  // Tam genişlik: sohbet ortada sıkışmasın, mevcut alanın tamamını kullansın
  return (
    <div className="w-full p-3 md:p-4" style={{ height: "calc(100vh - 76px)" }}>
      <AssistantChat withThreads voiceControlled />
    </div>
  );
}
